// !!!!!!!
// Front- és backend oldalon is használható, mert a crypto-js -t használjuk, nem a nodejs natív crypto-ját.
// !!!!!!!
//
// Eredeti crypto import
// 187kbyte → parsed 46kbyte
//
// import crypto from 'crypto-js/crypto-js'
//
// Csak a két szükséges modult importáljuk
// 84kbyte → parsed 15kbyte
//

// https://stackoverflow.com/questions/29509934/encrypt-with-cryptojs-and-decrypt-with-php

const AES  = require('crypto-js/aes')
const Utf8 = require('crypto-js/enc-utf8')

/**
 * @typedef {import('crypto-js').CipherOption} TCiperOption
 *
 * @typedef {(str: string, pass: string, options?: TCiperOption) => string} TCryptoFunction
 *
 * @typedef {Object} IAes
 * @property {TCryptoFunction} encrypt Az encrypt függvény.
 * @property {TCryptoFunction} decrypt A decrypt függvény.
 */

/** @type {IAes} */
const aes = {
  /**
   * Encrypt.
   * @param {string} str - A string, amit encryptelni szeretnénk.
   * @param {string} pass - A jelszó.
   * @param {TCiperOption} [options] - Opcionális ciper beállítások.
   * @returns {string} A kinyert adat.
   */
  encrypt: (str, pass, options) => {
    return AES
      .encrypt(str, pass, options)
      .toString()
  },

  /**
   * Decrypt.
   * @param {string} str - A string, amit decryptelni szeretnénk.
   * @param {string} pass - A jelszó.
   * @param {TCiperOption} [options] - Opcionális ciper beállítások.
   * @returns {string} A kinyert adat.
   */
  decrypt: (str, pass, options) => {
    return AES
      .decrypt(str, pass, options)
      .toString(Utf8)
  }
}

module.exports.aes = aes
